import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Marker } from '../../interfaces/marker.interface';
import { GlobeService } from '../globe.service'; // <-- Import GlobeService
import * as Cesium from 'cesium';
import { ReportMapEntity } from '../report-map-entity.service';
import { MarkersService } from './markers.service';
import { CameraService } from '../camera.service';
import { CoreService } from '../core.service';
import { WindowService } from '../window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from '../data-context.service';
import { TimelineService } from '../timeline.service';
// import { ReportMapEntity } from 'path-to-report-map-entity.service';

@Injectable({
  providedIn: 'root'
})
export class MarkersParentService {
  private globeClickSubject = new Subject<{ latitude: number; longitude: number }>();
  selectedMarkerIcon: { name: string; url: string } | null = null;

  constructor(private globeService: GlobeService,
    private markerSelectionService: MarkersService,
    private cameraService: CameraService,
    private coreService: CoreService,
    private windowService: WindowService,
    private dataContext: DataContextService,
    private modalService: NgbModal,
    private timelineService: TimelineService
  ) {}

  getGlobeClickObservable() {
    return this.globeClickSubject.asObservable();
  }

  handleGlobeClick(latitude: number, longitude: number): void {
    this.globeClickSubject.next({ latitude, longitude });
  }

  onMarkerSelected(marker: { name: string; url: string }) {
    this.selectedMarkerIcon = marker;
  }

  onGlobeClick(lat: number, lon: number) {
    const selectedMarker = this.markerSelectionService.getSelectedMarker();
    if (selectedMarker) {
      const markerId = 'marker-' + Date.now();
      const marker = new ReportMapEntity(
        markerId,
        selectedMarker.name,
        'Plugins//Markers',
        selectedMarker.url + '.png',
        lat,
        lon,
        0,
        new Date(),
        'Markers Plugin',
        this.cameraService,
        this.coreService,
        this.windowService,
        this.dataContext,
        this.modalService,
        this.timelineService
      );
      marker.setSource('Markers Plugin');
      marker.description = `This is a ${selectedMarker.name} marker.`; // Set a description if you want it to show in the infoBox

      const cesiumEntity = marker.getCesiumEntity();
      // Optionally, set description property for infoBox
      cesiumEntity.description = marker.description;

      this.globeService.getViewer()?.entities.add(cesiumEntity);
    }
  }

  addMarkerToMap(marker: Marker): void {
    const viewer = this.globeService.getViewer();
    if (!viewer) {
      console.error('Cesium viewer not initialized');
      return;
    }
    
    if (viewer.entities.getById(marker.id)) {    
      return;
    }
    viewer.entities.add({
      id: marker.id,
      position: Cesium.Cartesian3.fromDegrees(marker.longitude, marker.latitude),
      billboard: {
        image: marker.iconUrl,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      }
    });
  }

  removeMarkerFromMap(markerId: string): void {
    const viewer = this.globeService.getViewer();
    if (viewer) {
      viewer.entities.removeById(markerId);
    }
  }
}